<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kecamatan')">
              Kecamatan
              <i
                :class="
                  currentSort === 'kecamatan'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('desc')">
              desc
              <i
                :class="
                  currentSort === 'desc'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kodepos')">
              Kode Pos
              <i
                :class="
                  currentSort === 'kodepos'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ $get(list, 'district.desc') }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ list.kodepos }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/Kelurahan.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: 'id',
      currentSortDir: 'asc',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        desc: '',
        kecamatan: '',
        kodepos: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: 1,
          kecamatan: 'Medan Amplas',
          desc: 'Amplas',
          kodepos: '20229',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: 10,
          kecamatan: 'Medan Amplas',
          desc: 'Bangun Mulia',
          kodepos: '20149',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          kecamatan: 'Medan Amplas',
          desc: 'Harjosari I',
          kodepos: '20147',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          kecamatan: 'Medan Amplas',
          desc: 'Harjosari II',
          kodepos: '20147',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          id: 5,
          kecamatan: 'Medan Amplas',
          desc: 'Sitirejo II',
          kodepos: '20219',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          id: 6,
          kecamatan: 'Medan Amplas',
          desc: 'Sitirejo III',
          kodepos: '20219',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          id: 7,
          kecamatan: 'Medan Amplas',
          desc: 'Timbang Deli',
          kodepos: '20148',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          id: 8,
          kecamatan: 'Medan Area',
          desc: 'Kota Matsum I',
          kodepos: '20215',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          id: 9,
          kecamatan: 'Medan Area',
          desc: 'Kota Matsum II',
          kodepos: '20215',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          id: 2,
          kecamatan: 'Medan Area',
          desc: 'Kota Matsum IV',
          kodepos: '20215',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          id: 11,
          kecamatan: 'Medan Area',
          desc: 'Pandau Hulu II',
          kodepos: '20211',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          id: 12,
          kecamatan: 'Medan Area',
          desc: 'Pasar Merah Timur',
          kodepos: '20217',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          id: 13,
          kecamatan: 'Medan Area',
          desc: 'Sei Rengas II',
          kodepos: '20214',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          id: 14,
          kecamatan: 'Medan Area',
          desc: 'Sei Rengas Permata',
          kodepos: '20214',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          id: 15,
          kecamatan: 'Medan Area',
          desc: 'Sukaramai I',
          kodepos: '20216',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        kecamatan: data.kecamatan,
        kodepos: data.kodepos,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kelurahanData() {
      const result = this.$store.state.mdDatabaseStore.kelurahanData
      return result
    },
    sortedData() {
      return this.kelurahanData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
